import { useI18n } from 'core/i18n/I18nProvider';
import { localizedText } from 'shared/utilities/format';

const TYPE_CLASS = {
  key_strength: 'result-item-strength',
  professional_growth_challenge_opportunity: 'result-item-growth',
  suggested_career_path: 'result-item-path',
  skill_worth_developing: 'result-item-skill',
};

export function ResultContentCard({ item, locale }) {
  const { t } = useI18n();
  if (!item) {
    return null;
  }
  const type = item.type || 'key_strength';
  const title = localizedText(item, locale, ['title', 'name']);
  const description = localizedText(item, locale, ['description', 'body']);
  const advice = type === 'skill_worth_developing'
    ? localizedText(item, locale, ['advice'])
    : '';
  return (
    <article className={`result-item ${TYPE_CLASS[type] || ''}`} data-type={type} data-position={item.position ?? item.sort_order}>
      <p className="result-item-type">{t(`results.types.${type}`)}</p>
      {title ? <h3>{title}</h3> : null}
      {description ? <p>{description}</p> : null}
      {advice ? (
        <p className="result-advice">
          <strong>{t('results.advice')}: </strong>
          {advice}
        </p>
      ) : null}
    </article>
  );
}
